import { Announcements, ScreenReaderInstructions } from "@dnd-kit/core";

/**
 * Annunci e istruzioni per screen reader del trascinamento, in italiano.
 *
 * dnd-kit ne fornisce di predefiniti, ma in inglese: in un'app interamente
 * italiana un utente che naviga da tastiera si sentirebbe leggere metà
 * interfaccia in un'altra lingua. Sono anche l'unico riscontro che ha di ciò
 * che sta accadendo, visto che non vede l'anteprima muoversi.
 *
 * `over.id` è l'id del giorno di destinazione ("giorno:2026-07-28"): si mostra
 * la sola data, che è l'informazione utile.
 */
function giornoLeggibile(id: string | number | undefined): string {
  const testo = String(id ?? "");
  const iso = testo.includes(":") ? testo.split(":").pop() ?? testo : testo;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" });
}

export const istruzioniTrascinamento: ScreenReaderInstructions = {
  draggable:
    "Premi Spazio o Invio per iniziare a spostare questa scheda. " +
    "Usa le frecce per scegliere il giorno, poi premi di nuovo Spazio per confermare. " +
    "Premi Esc per annullare.",
};

export const annunciTrascinamento: Announcements = {
  onDragStart: ({ active }) => `Hai preso la scheda ${active.data.current?.scheda?.titolo ?? ""}.`,
  onDragOver: ({ over }) =>
    over ? `Scheda sopra il ${giornoLeggibile(over.id)}.` : "Scheda fuori dal calendario.",
  onDragEnd: ({ over }) =>
    over
      ? `Scheda spostata al ${giornoLeggibile(over.id)}.`
      : "Spostamento annullato: la scheda torna al suo posto.",
  onDragCancel: () => "Spostamento annullato.",
};
